export enum MessageCenterPaneClasses {
    MessageCenterPanel = 'show-message-center-panel',
    NewMessageCenterPanel = 'new-message-center-panel',
    MessageCenterPaneOpened = 'message-center-pane-opened',
    VpHideScrollbar = 'vp-hide-scrollbar'
}
